/** Nativer title-Tooltip für Kalender-Einträge: Beschreibung + Notizen,
 *  getrennt durch eine Leerzeile (Mehrzeilen-\n-Muster wie absence-tooltip.ts).
 *  Fallback für Blöcke, die zu klein sind, um die Notizen inline zu rendern. */
export function entryTooltip(description: string, notes: string | null | undefined): string {
  const d = description.trim()
  const n = (notes ?? '').trim()
  return n ? `${d}\n\n${n}` : d
}
